<template>
    <transition name="slide-down">
        <div v-if="isVisible" class="global-top-banner" :class="['type-' + type]">
            <div class="banner-content">
                <div>
                    <AlertTriangle v-if="type === 'error'" :size="18" fill="#b91c1c" stroke="transparent" class="ppv2-mr-3" />
                    <Info v-if="type === 'warning'" :size="18" color="white" class="ppv2-mr-3" />
                    <span class="poppinsRegular" :style="{ fontSize: normalizeFontSize(14) }">{{ message }}</span>
                </div>
                <div>
                    <a
                        v-if="actionLabel && actionUrl"
                        :href="actionUrl"
                        class="action-button poppinsMedium"
                        :style="{ fontSize: normalizeFontSize(13) }"
                    >
                        {{ actionLabel }}
                    </a>
                </div>
                <button v-if="closeable" @click="closeBanner" class="close-button">
                    <X :size="20" color="white" />
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
import { AlertTriangle, X, Info } from 'lucide-vue'
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'GlobalTopBanner',
    components: {
        AlertTriangle,
        X,
        Info,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'info', // 'error', 'info', or 'warning'
        },
        message: {
            type: String,
            required: true,
        },
        actionLabel: {
            type: String,
            default: '',
        },
        actionUrl: {
            type: String,
            default: '',
        },
        closeable: {
            type: Boolean,
            default: true,
        },
        persistClose: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isVisible: false,
        }
    },
    mounted() {
        if (this.persistClose) {
            const isClosed = localStorage.getItem(`banner_closed_${this.id}`)
            if (!isClosed) {
                this.isVisible = true
            }
        } else {
            this.isVisible = true
        }
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        closeBanner() {
            this.isVisible = false
            if (this.persistClose) {
                localStorage.setItem(`banner_closed_${this.id}`, 'true')
            }
        },
    },
}
</script>

<style scoped>
.global-top-banner {
    width: 100%;
    position: relative;
    z-index: 9999;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    min-height: 40px;
    box-sizing: border-box;
}

.type-error {
    background-color: #b91c1c; /* Red color from image */
    color: white;
}

.type-info {
    background-color: #7d2dbd; /* Purple color from image */
    color: white;
}

.type-warning {
    background-color: #e07f00; /* Warning orange/yellow from image */
    color: white;
}

.banner-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 0 55px; /* Alignment with header padding */
}

.banner-left {
    display: flex;
    align-items: center;
    flex: 1;
}

.message {
    font-size: clamp(12px, 0.729545vw, 16px);
    line-height: 1.4;
}

.banner-right {
    display: flex;
    align-items: center;
    gap: 20px;
}

.action-button {
    background: transparent;
    border: 1px solid white;
    color: white;
    padding: 4px 20px;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.action-button:hover {
    background: rgba(255, 255, 255, 0.1);
}

.close-button {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    transition: opacity 0.2s ease;
}

.close-button:hover {
    opacity: 1;
}

/* Animations */
.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-down-enter-from,
.slide-down-leave-to {
    transform: translateY(-100%);
}
</style>
